import { createRouter, createWebHistory } from "vue-router";
import { h } from "vue";
import LoginPage from "@/views/softwares/common/LoginPage.vue";
import LoginPage3 from "@/views/softwares/common/LoginPage3.vue";
import PaymentResult from "@/views/softwares/common/paymentResult.vue";
// واکشی تمام کامپوننت‌های vue در مسیر ../views/softwares به صورت داینامیک با require.context
const pages = require.context("../views/softwares", true, /\.vue$/);

function resolveComponent(software, page) {
  // First try the canonical location: ./<software>/<page>.vue
  const filePath = `./${software}/${page}.vue`;
  if (pages.keys().includes(filePath)) {
    return pages(filePath).default;
  }

  // Fallback: try to find any file whose filename matches the page (e.g. print-check/record-check.vue)
  const fallbackKey = pages.keys().find((k) => k.endsWith(`/${page}.vue`));
  if (fallbackKey) {
    return pages(fallbackKey).default;
  }

  // Not found
  return null;
}

const router = createRouter({
  history: createWebHistory(""),
  routes: [
    // This new rule redirects the user to your desired default page.
    {
      path: '/Login',
      name: 'Login',
      component: LoginPage,
    },

    {
      path: '/',
      name: 'Login3',
      component: LoginPage3,
    },
    {
      path: '/payment-result/:invoiceId',
      name: 'PaymentResult',
      component: PaymentResult
    },
    {
      path: '/company-setup',
      name: 'CompanySetup',
      meta: { requiresAuth: true },
      component: () => import('../views/softwares/common/CompanySetup.vue')
    },
    {
      path: "/overview",
      name: "CommandDesk",
      meta: { requiresAuth: true },
      component: () => import("../pages/CommandDesk.vue"),
      children: [
        {
          path: "", // The empty path makes it the default child
          name: "OverviewDashboard",
          component: () => import("../pages/OverviewDashboard.vue"),
        },
        {
          path: "test",
          name: "TestPage",
          component: () => import("../pages/Test.vue"),
        },
        {
          path: ":software",
          component: () => import("../layouts/SoftwareLayout.vue"),
          children: [
            {
              path: ":page",
              name: "SoftwarePage",
              // --- بخش اصلی تغییرات اینجاست ---
              component: {
                render() {
                  const { software, page } = this.$route.params;
                  const ResolvedComponent = resolveComponent(software, page);

                  // اگر کامپوننت پیدا شد، آن را رندر کن
                  if (ResolvedComponent) {
                    return h(ResolvedComponent);
                  }
                  // در غیر این صورت، چیزی نمایش نده تا به 404 منتقل شود
                  return null;
                },
              },
              // گارد ما حالا فقط وظیفه چک کردن و هدایت به 404 را دارد
              beforeEnter: (to, from, next) => {
                const { software, page } = to.params;
                // If no page is provided (navigating to /overview/:software), allow it so
                // the SoftwareLayout renders and the sidebar becomes available.
                if (!page) {
                  next();
                  return;
                }

                // If a page is provided, ensure the component exists; otherwise go to 404
                if (resolveComponent(software, page)) {
                  next(); // component exists, proceed
                } else {
                  next("/404"); // not found, redirect to 404
                }
              },
            },
          ],
        },
      ],
    },
    { path: "/:pathMatch(.*)*", redirect: "/overview" },
    // اگر روتی برای 404 تعریف نکرده‌اید، می‌توانید اضافه کنید
    // { path: '/404', name: 'NotFound', component: () => import('../views/NotFound.vue') }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: "smooth" };
    return { top: 0 };
  },
});

// Global guard: ensure that if company isn't active, user is redirected to company setup
router.beforeEach((to, from, next) => {
  try {
    const companyActive = localStorage.getItem('companyisactive');
    if (to.fullPath.startsWith('/overview') && companyActive === 'false') {
      next('/company-setup');
      return;
    }
  } catch (e) {
    // ignore if localStorage is not available
  }
  next();
});

export default router;
